export default class Globais{
  /**************************************************************************** */
  // Elastic BeansTalk
  /**************************************************************************** */
  //Url para desenvolvimento
  // static url_base = "http://localhost:5000/api"; // Atualize para o endpoint do backend na AWS
  // static url_base_relatorio = "http://localhost:5000/relatorio/download/"; // Atualize para o endpoint do backend na AWS
  //
  //Url para testes - HTTP
  // static url_base = "http://testegqff-env.eba-4dxixsmc.us-east-1.elasticbeanstalk.com/api"; // Atualize para o endpoint do backend na AWS
  // static url_base_relatorio = "http://testegqff-env.eba-4dxixsmc.us-east-1.elasticbeanstalk.com/relatorio/download/"; // Atualize para o endpoint do backend na AWS
  
  //Url para testes - HTTPS
  // static url_base = "https://testegqff-env.eba-4dxixsmc.us-east-1.elasticbeanstalk.com/api"; // Atualize para o endpoint do backend na AWS
  // static url_base_relatorio = "https://testegqff-env.eba-4dxixsmc.us-east-1.elasticbeanstalk.com/relatorio/download/"; // Atualize para o endpoint do backend na AWS

  // static url_base = "https://TesteGQFF-env.eba-4dxixsmc.us-east-1.elasticbeanstalk.com/api";
  // static url_base_relatorio = "https://TesteGQFF-env.eba-4dxixsmc.us-east-1.elasticbeanstalk.com/relatorio/download"
  // static url_base = "https://gqffteste.asciisolucoes.com.br/api"; // Atualize para o endpoint do backend na AWS
  // static url_base_relatorio = "https://gqffteste.asciisolucoes.com.br/relatorio/download/"; // Atualize para o endpoint do backend na AWS
  
  //URL Produção
  //static url_base = "https://6xu5m495bh.execute-api.us-east-1.amazonaws.com";    
  //static url_base_relatorio = "http://testegqff-env.eba-4dxixsmc.us-east-1.elasticbeanstalk.com/relatorio/download/"; // Atualize para o endpoint do backend na AWS
  // static versao_teste = 'Não';

  /**************************************************************************** */
  // API e Lambda
  /**************************************************************************** */
  //Url para teste - API e Lambda
  static url_base_api = "https://ougklome0d.execute-api.us-east-1.amazonaws.com";
  static versao_api = "V02";

  //URL Produção - API e Lambda
  // static url_base = "https://6xu5m495bh.execute-api.us-east-1.amazonaws.com";    
  // static versao_api = "v03";
  
  static url_consulta = this.url_base_api + "/" + this.versao_api + "/consulta";
  static url_inclusao = this.url_base_api + "/" + this.versao_api + "/inclusao";
  static url_alteracao = this.url_base_api + "/" + this.versao_api + "/alteracao";
  static url_exclusao = this.url_base_api + "/" + this.versao_api + "/exclusao";

  static url_inclusao_ordem = this.url_base_api + "/" + this.versao_api + "/inclusaoordem";
  static url_alteracao_ordem = this.url_base_api + "/" + this.versao_api + "/alteracaoordem";
  static url_exclusao_ordem = this.url_base_api + "/" + this.versao_api + "/exclusaoordem";

  static url_inclusao_analise = this.url_base_api + "/" + this.versao_api + "/inclusaoanalise";
  static url_alteracao_analise = this.url_base_api + "/" + this.versao_api + "/alteracaoanalise";
  static url_exclusao_analise = this.url_base_api + "/" + this.versao_api + "/exclusaoanalise";

  static url_inclusao_documento = this.url_base_api + "/" + this.versao_api + "/inclusaodocumento";
  static url_alteracao_documento = this.url_base_api + "/" + this.versao_api + "/alteracaodocumento";
  static url_exclusao_documento = this.url_base_api + "/" + this.versao_api + "/exclusaodocumento";

  // static url_relatorios = this.url_base_api_relatorios + "/" + this.versao_api_relatorios + "/relatorios";
  static url_relatorios = this.url_base_api + "/" + this.versao_api + "/relatorios";

  static url_upload_zip = this.url_base_api + "/" + this.versao_api + "/uploadzip";
  /**************************************************************************** */

  /*************************************************************************** */
  // Variáveis para apresentar as fotos e documentos de aprovação
  /*************************************************************************** */
  static bucketName = 'gqff-bucket';
  static regionName = 'us-east-1';
  static folderName = 'fotos';
  static folderDocName = 'documentos'
  static folderUpload = 'arquivos/upload/temp'
  /*************************************************************************** */

  static nome_sistema = "Gerenciamento da Qualidade Funcional de Fluidos - GQFF";
  static qtd_linhas = 15;
  static nome_empresa = "Analub";
  static created_by = "ASCII Soluções"
  static versao = "1.0.0"
  static dia_periodo = "21"

  static versao_teste = 'Sim';
}